import axios from "axios";
import {jwtDecode} from "jwt-decode"

import AsyncStorageFunc from '../utilities/asyncStorage'
import RootNavigation from "../utilities/RootNavigation";

class ApiService {
  

  async post(path, payload, headers) {
      let deviceId = await AsyncStorageFunc.getData('deviceId');
      const header ={
        deviceModel: "",
        appVersion: "",
        platform: "",
        network: "",
        deviceId:deviceId,
        fcmToken : ""
      } 
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: path,
        data: payload,
        headers: headers ? headers : header,
      })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err)
        });
    });
  }

  //get method
  async get(path,params,headers) {
    params = params || {}
    let deviceId = await AsyncStorageFunc.getData('deviceId');
    const header ={
      deviceModel: "",
      appVersion: "",
      platform: "",
      network: "",
      deviceId:deviceId,
      fcmToken : ""
    } 
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: path,
        params:params,
        headers: headers ? headers : header
      })
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (err) {
          if (
            err?.response &&
            err?.response?.status === 401 &&
            (err?.response?.data?.message == "User Logged in Other Device" ||
              err?.response?.data?.message == "User already logged out" ||
              err?.response?.data?.message == "Session timeout, please login")
          ) {
            AsyncStorageFunc.deleteData("TOKEN").then((tokenRes) => {
              RootNavigation.navigate("Login", {
                message: err?.response?.data?.message,
              });
            });
          } else {
            reject(
              err?.response?.data?.message
                ? err.response.data
                : err?.message
                ? err
                : {
                    message:
                      "Server is currently unavailable.Request you try after sometime",
                  }
            );
          }
        });
    });
  }

   getWithToken= async (path, params, header) =>{
    let deviceId = await AsyncStorageFunc.getData('deviceId');
     let token = await AsyncStorageFunc.getData('TOKEN');
     var decoded = token ? jwtDecode(token) : "";
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: path,
        params: params,
        headers: header
          ? header
          : {
              Authorization: "bearer " + token,
              deviceModel: "",
              appVersion: "",
              platform: "",
              network: "",
              deviceId: deviceId,
              userId: decoded.userCd,
            },
      })
        .then(function (response) {
          resolve(response.data);
        })
        .catch((err) => {
          if (
            err?.response &&
            err?.response?.status === 401 &&
            (err?.response?.data?.message == "User Logged in Other Device" ||
              err?.response?.data?.message == "User already logged out" ||
              err?.response?.data?.message == "Session timeout, please login")
          ) {
            global.TimeoutError = err?.response?.data?.message
            AsyncStorageFunc.deleteData("TOKEN").then((tokenRes) => {
              RootNavigation.navigate("Login", {
                message: err?.response?.data?.message,
              });
            });
          } else {
            reject(
              err?.response?.data?.message
                ? err.response.data
                : err?.message
                ? err
                : {
                    message:
                      "Server is currently unavailable.Request you try after sometime",
                  }
            );
          }

        });
    });
  }

  async postwithtoken(path, payload, userId, headers) {

    let token = await AsyncStorageFunc.getData('TOKEN');
    let deviceId = await AsyncStorageFunc.getData('deviceId');
    var decoded = token ? jwtDecode(token) : "";
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        headers: headers
          ? headers
          : {
              Authorization: token ? "bearer " + token : "",
              deviceModel: "",
              appVersion: "",
              platform: "FF_PORTAL",
              network: "",
              deviceId: deviceId,
              userId:decoded.userCd
            },
        url: path,
        data: payload,
      })
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (err) {
          if (
            err?.response &&
            err?.response?.status === 401 &&
            (err?.response?.data?.message == "User Logged in Other Device" ||
              err?.response?.data?.message == "User already logged out" ||
              err?.response?.data?.message == "Session timeout, please login")
          ) {
            global.TimeoutError = err?.response?.data?.message
            AsyncStorageFunc.deleteData("TOKEN").then((tokenRes) => {
              RootNavigation.navigate("Login", {
                message: err?.response?.data?.message,
              });
            });
          } else {
            reject(
              err?.response?.data?.message
                ? err.response.data
                : err?.message
                ? err
                : {
                    message:
                      "Server is currently unavailable.Request you try after sometime",
                  }
            );
          }
        });
    });
  }

  
  
}

  export default new ApiService();
